// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"327b780d","453":"74b5180f","455":"36b179a9","729":"cbeadfe3","977":"e9cf6a0f"}[chunkId] + ".chunk.js";
};